module.exports = __webpack_public_path__ + "img/informal-settlements-iamp57.5db4f8e9.png";